module.exports = __webpack_public_path__ + "img/stock7.8e9dafbc.png";